import { PelletsArticleData } from "~/types/Pellets";

export const pelletsArticles: PelletsArticleData[] = [
  {
    title: "Aktuelle Pelletspreise: Was den Preis beeinflusst",
    contentParagraphs: [
      "Holzpellets werden zu rund 90 Prozent aus Sägespänen und Holzresten hergestellt, die als Nebenprodukte der Sägeindustrie anfallen. Steigen die Holzpreise oder sinkt das Sägewerksaufkommen, wirkt sich das direkt auf die Pelletspreise aus. Hinzu kommt die Saisonalität: In den Sommermonaten, wenn die Heiznachfrage gering ist, liegen die Pelletspreise historisch deutlich niedriger als in der Heizperiode ab Herbst. Wer seinen Jahresbedarf im Frühjahr oder Frühsommer bestellt, zahlt in der Regel weniger pro Tonne.",
    ],
    imageSrc: require("~/assets/images/pellets/aktuelle-pelletspreise.webp"),
    imageAlt: "Aktuelle Pelletspreise",
    imagePosition: "left",
  },
  {
    title: "Wie viel kosten Pellets pro Tonne und wie viel benötige ich?",
    contentParagraphs: [
      "Bei einem Jahreswärmebedarf von rund 20.000 kWh werden etwa vier Tonnen Pellets benötigt, bei 25.000 kWh entsprechend fünf Tonnen. Wichtig dabei: Der Preis pro Tonne sinkt oft mit steigender Abnahmemenge. Wer den Jahresbedarf in einer Lieferung deckt statt in mehreren kleineren Bestellungen, zahlt häufig weniger. Es lohnt sich also, den Lagerraum voll auszuschöpfen.",
    ],
    imageSrc: require("~/assets/images/pellets/kosten-pellets.webp"),
    imageAlt: "Pellets Kosten pro Tonne",
    imagePosition: "right",
  },
  {
    title: "Warum die Preise regional schwanken",
    contentParagraphs: [
      "Die regionalen Unterschiede bei den Pelletspreisen entstehen durch mehrere Faktoren gleichzeitig: Transportkosten, Händlerdichte und regionale Nachfrage. Je weiter der Lieferweg vom Produktionsstandort, desto höher der Logistikkostenanteil am Endpreis. Pelletwerke liegen in Deutschland überwiegend in waldreichen Regionen mit starker Sägeindustrie, primär in Mittelgebirgsregionen. Welche Bundesländer aktuell am günstigsten sind, zeigen die Live-Preisdaten oben, da sich das regionale Preisgefüge je nach Saison und Angebotslage verschieben kann.",
    ],
    imageSrc: require("~/assets/images/pellets/preise-regional.webp"),
    imageAlt: "Regionale Pelletspreise",
    imagePosition: "left",
  },
  {
    title: "Marktentwicklung: Pelletsproduktion in Deutschland",
    contentParagraphs: [
      "Deutschland ist der größte Pelletsproduzent innerhalb der EU und exportiert netto, die heimische Produktion übersteigt den inländischen Verbrauch. Das ist ein stabilisierender Faktor für die Pelletspreise: Anders als bei Öl oder Gas besteht keine Abhängigkeit von Importen aus einzelnen Lieferländern. Die wachsende Zahl an Pelletsheizungen in Deutschland wird durch den kontinuierlichen Ausbau der Produktionskapazitäten bisher gut aufgefangen.",
    ],
    imageSrc: require("~/assets/images/pellets/Pelletsproduktion.webp"),
    imageAlt: "Pelletsproduktion in Deutschland",
    imagePosition: "right",
  },
  {
    title: "Pelletspreise vergleichen: Bevor Sie bestellen",
    contentParagraphs: [
      "Die Unterschiede zwischen den günstigsten und teuersten Anbietern in Ihrer Region können einige Euro pro Bestellung ausmachen. Neben dem Grundpreis pro Tonne spielen Lieferentfernung, Mindestabnahmemenge und Lieferform (lose Ware, oder Sackware) eine wesentliche Rolle. Geben Sie oben Ihre Postleitzahl und die gewünschte Menge ein, um die verfügbaren Händler in Ihrer Region mit aktuellen Preisen direkt zu vergleichen.",
    ],
    imageSrc: require("~/assets/images/pellets/pelletspreise-vergleichen.webp"),
    imageAlt: "Pelletspreise vergleichen",
    imagePosition: "left",
  },
];
